/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Action_View_DocumentInputs */

const en_notifications_action_view_document = /** @type {(inputs: Notifications_Action_View_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View document`)
};

const pt_br2_notifications_action_view_document = /** @type {(inputs: Notifications_Action_View_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver documento`)
};

/**
* | output |
* | --- |
* | "View document" |
*
* @param {Notifications_Action_View_DocumentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_action_view_document = /** @type {((inputs?: Notifications_Action_View_DocumentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Action_View_DocumentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_action_view_document(inputs)
	return pt_br2_notifications_action_view_document(inputs)
});